var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import _ from 'lodash';
import { toDetail } from "../../../helper/util";
import { EBillType } from "../../../enum/EBillType";
import EHandleStatus from '../../../enum/EHandleStatus';
import Add from '../Add';
import GlobalVue from "../../../globalVue";
import PageService from '../../../api/PageService';
import OperationReportService from '../../../api/OperationReportService';
import DeliverService from '../../../api/DeliverService';
import KeyConfig from '../../../components/common/KeyConfig.vue';
import BillSubTable from "../../../components/bill/BillSubTable.vue";
var TableList = (function (_super) {
    __extends(TableList, _super);
    function TableList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.colmuns = [];
        _this.multiColmuns = [];
        _this.dataSource = [];
        _this.total = 0;
        _this.tableKey = 1;
        _this.eBillType = EBillType;
        _this.type = 'entrustedDeliver';
        return _this;
    }
    TableList.prototype.watchCols = function (newCols, oldCols) {
        console.log('newCols:%o', newCols);
        if (newCols) {
            this.colmuns = newCols;
            this.renderTable();
        }
    };
    TableList.prototype.layoutTable = function () {
        var _this = this;
        this.$nextTick(function () {
            var table = _this.$refs.Table;
            table.resizeListener();
            _this.$nextTick(function () {
                var fixedLeft = table.$el.querySelector('.el-table__fixed');
                var fixedRight = table.$el.querySelector('.el-table__fixed-right');
                if (fixedLeft) {
                    fixedLeft.style.height = (table.layout.tableHeight - table.layout.gutterWidth) + 'px';
                }
                if (fixedRight) {
                    fixedRight.style.height = (table.layout.tableHeight - table.layout.gutterWidth) + 'px';
                }
            });
        });
    };
    TableList.prototype.created = function () {
        console.log(555, this.fetchAction);
        this.service = PageService.getInstance();
        this.serviceList = OperationReportService.getInstance();
        this.deliverservice = DeliverService.getInstance();
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.getPageConfig(this.fetch);
    };
    TableList.prototype.renderTable = function () {
        this.tableKey = Math.random();
    };
    TableList.prototype.initColmun = function (colmuns) {
        var _this = this;
        var freezeIndex = colmuns.findIndex(function (item) { return item.is_freeze; });
        colmuns.map(function (item, index) {
            if (_this.filterColumns.includes(item.key)) {
                item.rowHidden = true;
                item.is_hidden = 1;
            }
            if (item.type && colmuns[index + 1] && item.type === colmuns[index + 1].type) {
                item.freezeDisabled = true;
            }
            if (index <= freezeIndex) {
                item.fixed = true;
            }
            else {
                item.fixed = false;
            }
            return item;
        });
        if (this.isMultiHeader) {
            var multiColmuns = _.cloneDeep(colmuns);
            this.multiColmuns = this.multiColmunsSet(multiColmuns);
        }
        return colmuns;
    };
    TableList.prototype.configUpdate = function (configData) {
        this.colmuns = this.initColmun(configData);
        this.renderTable();
    };
    TableList.prototype.showKeyConfig = function () {
        this.$refs.KeyConfig.show(this.colmuns, this.templateType);
    };
    TableList.prototype.selectionChange = function (val) {
        this.$emit('selectionChange', val);
    };
    TableList.prototype.getPageConfig = function (callBack) {
        var _this = this;
        if (!this.isShowKeyConfig)
            return;
        this.service
            .getPage({
            template_type: this.templateType,
        })
            .then(function (res) {
            var DATA = res.data.data;
            _this.colmuns = Array.isArray(DATA.template_config) ? _this.initColmun(DATA.template_config) : [];
        })
            .catch(function (err) {
            _this.loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    TableList.prototype.fetch = function (pager, updatePager, renderTable) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        if (renderTable === void 0) { renderTable = true; }
        var pagination = this.$refs.pagination;
        var currentPager = pagination ? pagination.getPage() : pager;
        if (pager.page === 1 && pagination && !updatePager) {
            pagination.handleCurrentChange(1);
            return;
        }
        var params = {
            page: currentPager.page || 1,
            start: currentPager.start || 0,
            limit: currentPager.limit || 20,
            sort_field: this.order ? this.order[0] : null,
            sort_type: this.order ? this.order[1] : null
        };
        this.fetchAction(Object.assign({}, this.filter, params))
            .then(function (res) {
            _this.$refs.Table.clearSelection();
            _this.loadingInstance.close();
            var DATA = Array.isArray(res.data.data) ? res.data.data : [];
            DATA.map(function (item) {
                item.listGoods = [];
            });
            _this.dataSource = DATA;
            _this.layoutTable();
            _this.$emit('fetchCallBack', res.data);
            _this.total = res.data.total;
            renderTable && _this.renderTable();
        })
            .catch(function (err) {
            _this.loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    TableList.prototype.pageChange = function (pager) {
        this.fetch(pager, true);
    };
    TableList.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (prop) {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        else {
            this.order = null;
        }
        this.loadingInstance = Loading.service({ fullscreen: true });
        this.fetch({ page: 1, start: 0, limit: 20 }, false, false);
    };
    TableList.prototype.lookDetail = function (row) {
        toDetail(EBillType.EntrustedDeliver, row.order_id);
    };
    TableList.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    TableList.prototype.editDeliver = function (row) {
        this.addTab({
            component: Add,
            title: '修改委托送货单',
            showExist: true,
            name: '修改委托送货单' + row.order_id,
            cprops: {
                handleStatus: EHandleStatus.Edit,
                order_id: row.order_id
            }
        });
    };
    TableList.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.dataSource.indexOf(row);
        this.deliverservice.getListGoods(params).then(function (res) {
            _.forEach(res.data.data, function (item) {
                item.amount = item.order_detail_amount;
            });
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            _this.dataSource[index].listGoods = listGoods;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    __decorate([
        Prop({
            default: document.documentElement.clientHeight - 240,
        })
    ], TableList.prototype, "tableHeight", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "cols", void 0);
    __decorate([
        Prop({
            required: true,
        })
    ], TableList.prototype, "fetchAction", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "dataActions", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "sortColumns", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "filterColumns", void 0);
    __decorate([
        Prop({
            default: {},
        })
    ], TableList.prototype, "filter", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "showSummary", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "setSummary", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "isShowKeyConfig", void 0);
    __decorate([
        Prop({
            default: 1,
        })
    ], TableList.prototype, "templateType", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "renderTitleKeys", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
        })
    ], TableList.prototype, "renderContentKeys", void 0);
    __decorate([
        Prop({
            default: false,
        })
    ], TableList.prototype, "isMultiHeader", void 0);
    __decorate([
        Prop({
            default: function () { },
        })
    ], TableList.prototype, "multiColmunsSet", void 0);
    __decorate([
        Prop({
            default: false
        })
    ], TableList.prototype, "checkbox", void 0);
    __decorate([
        Watch('cols', { immediate: true })
    ], TableList.prototype, "watchCols", null);
    TableList = __decorate([
        Component({
            components: {
                KeyConfig: KeyConfig,
                BillSubTable: BillSubTable
            },
        })
    ], TableList);
    return TableList;
}(Vue));
export default TableList;
